module.exports = __webpack_public_path__ + "img/7F5134_22120A_452110_9F7D5F-256px.75eff193.png";